import { Search, BarChart3, ShoppingBag, FolderTree } from "lucide-react";
import { useTranslation } from "@/i18n";

const KeywordHighlight = () => {
  const { t } = useTranslation();

  const cards = [
    {
      icon: BarChart3,
      titleKey: "keywordHighlight.card1.title",
      descriptionKey: "keywordHighlight.card1.description",
      gradient: "from-primary/20 to-accent/20",
    },
    {
      icon: ShoppingBag,
      titleKey: "keywordHighlight.card2.title",
      descriptionKey: "keywordHighlight.card2.description",
      gradient: "from-accent/20 to-primary/20",
    },
    {
      icon: FolderTree,
      titleKey: "keywordHighlight.card3.title",
      descriptionKey: "keywordHighlight.card3.description",
      gradient: "from-primary/15 to-accent/25",
    },
  ];

  return (
    <section className="py-20 md:py-32 relative overflow-hidden bg-[#0f1117]">
      {/* Subtle central glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-primary/[0.07] blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 text-sm font-medium mb-6">
            <Search size={16} className="text-primary" />
            <span className="text-white/80">{t('keywordHighlight.badge')}</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {t('keywordHighlight.title')}
          </h2>
          <p className="text-lg text-white/60">
            {t('keywordHighlight.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {cards.map((card, index) => (
            <div
              key={index}
              className="group p-6 md:p-8 rounded-2xl bg-white/[0.06] border border-white/10 backdrop-blur-sm hover:bg-white/10 hover:-translate-y-1 transition-all duration-300"
            >
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${card.gradient} flex items-center justify-center mb-5 transition-transform group-hover:scale-110`}>
                <card.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                {t(card.titleKey)}
              </h3>
              <p className="text-white/50 leading-relaxed">
                {t(card.descriptionKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeywordHighlight;
